<template>
    <table  v-if='dataTables' class="table">
        <thead>
            <tr>
                <th v-for="(item, index) in cols" v-bind:key="index" v-on:click="changeSort(item.id)">{{item.label}}</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="(item, index) in dataTables" v-bind:key="index">
                <td v-for="(item2, index2) in cols" v-bind:key="index2">{{item[item2['name']]}}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "ftsTable",
    data() {
        return {

        }
    },
    props: {
        cols: Array,
        dataToTable: Array,
        dataTables: Object|Array
    },
    mounted() {
        console.log(this.dataTables)
        console.log(this.cols)
    }
}
</script>

<style lang="scss">

</style>